import { intercomService } from "@services/intercomService";
import { WSEmptyState } from "@wingspanhq/fe-component-library";

type Props = {
  onRetry: () => void;
};

export const EmptySpaceErrorMessage: React.FC<Props> = props => {
  return (
    <WSEmptyState
      hasBorder
      orientation="horizontal"
      type="tasks"
      title="We had trouble loading part of this page"
      description={
        <>
          If this problem persists, please{" "}
          <a onClick={intercomService.open}>contact support</a>
        </>
      }
      actions={{
        buttons: [
          {
            label: "Retry",
            onClick: props.onRetry
          }
        ]
      }}
    />
  );
};
